import styled from 'styled-components';

export const ThumbnailOverlay = styled.div`
  background-color: #fcfcfc;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  height: 142px;
  opacity: ${props => (props.isLoading || props.ignored ? 0.85 : 0)};
  padding-top: 42px;
  margin-top: -142px;
  transition: opacity 250ms ease;
  width: 188px;
  position: relative;
  bottom: 28px;

  &::after {
    color: #5a5a5a;
    display: block;
    font-family: Avenir Next Airbo;
    font-size: 16px;
    font-stretch: normal;
    font-style: normal;
    font-weight: 500;
    letter-spacing: 1px;
    line-height: normal;
    margin-top: 42px;
    text-align: center;
    text-align: center;
    text-transform: uppercase;
    transition-duration: 0.3s;
    transition-property: margin-top;
  }
`;

export const Overlay = styled.div`
  opacity: 0;
  transition: opacity 250ms ease;

  ul > li.destroy.pill.right {
    margin-left: 10px;
  }
`;

export const SmallTileContainer = styled.div`
  background-color: #fcfcfc;
  border-radius: 8px;
  box-shadow: 0px 6px 12px 0px #00000014;
  height: 233px;
  width: 188px;
  position: relative;

  &:hover ${ThumbnailOverlay} {
    opacity: 0;
  }

  &:hover ${Overlay} {
    opacity: 1;
  }
`;

export const VideoThumbnail = styled.div`
  width: 188px;
  height: 142px;
  overflow: hidden;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;

  > iframe {
    max-width: 188px;
    max-height: 142px;
  }
`;

export const Thumbnail = styled.img`
  width: 188px;
  height: 142px;
  object-fit: cover;
  image-rendering: pixelated;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
`;

export const Headline = styled.div`
  font-family: Montserrat, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  line-height: 13px;
  height: 32px;
  letter-spacing: normal;
  line-height: normal;
  padding: 10px;
  width: 168px;
  position: relative;
  bottom: 31px;
`;

export const StyledLoading = styled.div`
  display: block;
  width: 100%;
  height: 100%;
  bottom: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.92);
  z-index: 1;
`;

export const TileButtons = styled.ul`
  margin-top: -164px;
  margin-right: 5px;
  z-index: 9;
  width: auto;
  position: relative;
  bottom: 28px;
  li {
    height: 24px;
  }
`;

export const RibbonTagAndIncompleteTagWrapper = styled.div`
  display: flex;
  justify-content: ${props =>
    props.hasRibbonTag ? 'space-between' : 'flex-end'};
  position: relative;
  bottom: 28px;
  height: 28px;
`;
